var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptySavedCourses = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 143,
  height: 150,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00DD80",
  d: "M118.084 46.447h24.684V150h-24.684z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M118.084 46.447h24.684V150h-24.684z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00AA95",
  d: "M118.084 75.38h24.684v24.966h-24.684z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  d: "M118.084 75.38h24.684v24.966h-24.684z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB3737",
  d: "M51.827 30.192h40.076V150H51.827z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C30000",
  d: "M55.987 125.423h31.756v8.322H55.987zM67.69 63.285h8.321v53.621h-8.32zM55.987 46.447h31.756v8.322H55.987z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  d: "M83.787 15h17.981v135h-18V15z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M83.578 38.126h18.19v8.321H83.555v-8.321z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E76E5",
  d: "M101.443 8h24.961v142h-24.961z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#656565",
  d: "M101.443 8h24.961v142h-24.961z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  d: "M28.768 0h31v150h-31z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M.768 22h28v128h-28z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E50B5",
  d: "M40.095 22h8.32v35.46h-8.32z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  d: "M.768 34h27.568v8.322H.767zM.768 125.034h27.568v8.322H.767z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#292929",
  d: "M101.768 23h24.683v63h-24.683z"
})));
export default SvgEmptySavedCourses;